module.exports = __webpack_public_path__ + "assets/img/tx110_2.a9ac4738.jpg";